
import MansionBuildData from "./MansionBuildData";

export default class MansionBuildDataManage {

    mansionBuildData = new MansionBuildData();
 
    loadLocationData() {
        this.mansionBuildData.loadLocalData();
    }

    saveAllLocationData() {
        this.mansionBuildData.saveLocalData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {

    }
}
